export default __webpack_public_path__ + "media/templatesEmptyState.0455a610.png";